export const cleavageHudId = 'cleavageHud';
